
/**
 *   AUTO GENERATED FILE. DO NOT EDIT.
 */
export const version = '1.37.2';
